// export const BASE_URL = 'https://localhost:44338/api';
//export const BASE_URL ='https://localhost:44312/api';
export const BASE_URL ='https://ventureapi.coolboiler.com/api';
export const BASE_URL2 ='https://localhost:44317/api';
export const BASE_URL3 ='https://localhost:44369/api';
export const IMG_URL2 ='https://localhost:44317/images/';
                           